import PropTypes from "prop-types";
import React from "react";
import { Col, Container, Row } from "reactstrap";

// Pages Components
import LatestTransaction from "./DatadogApiEndpoints"; // Assuming you have a component for New Relic Transactions named "NewRelicTransactions"

//Import Breadcrumb

//i18n
import { withTranslation } from "react-i18next";

//redux

const DatadogApiEndpoints = (props) => {
    //meta title
    document.title = "DatadogApiEndpoints | Temperstack";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}

                    <Row>
                        <Col lg="12">
                            <LatestTransaction />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

DatadogApiEndpoints.propTypes = {
    t: PropTypes.any,
    chartsData: PropTypes.any,
    onGetChartsData: PropTypes.func,
};

export default withTranslation()(DatadogApiEndpoints);
